import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import cn from 'classnames';
import React from 'react';

import s from './Modal.module.scss';

interface ModalProps extends Omit<DialogProps, 'title'> {
  title?: React.ReactNode;
  withPadding?: boolean;
  backroundedHeader?: boolean;
  loading?: boolean;
  onClose: () => void;
}

const Modal = ({
  open,
  title,
  onClose,
  children,
  withPadding,
  backroundedHeader,
  loading,
  ...rest
}: ModalProps) => {
  const loadingBackround = loading
    ? {
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        }
      }
    : {};

  return (
    <Dialog
      onClose={onClose}
      open={open}
      className={s.Modal}
      {...rest}
      PaperProps={{
        ...loadingBackround,
        sx: loading ? { transition: 'none' } : {},
        ...rest.PaperProps
      }}
      TransitionProps={{ timeout: { enter: 0, exit: 0 } }}
    >
      <>
        {loading && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              overflow: 'hidden'
            }}
          >
            <CircularProgress sx={{ color: '#fff' }} />
          </Box>
        )}
        <Box className={s.Modal__main} sx={{ display: loading ? 'none' : 'block' }}>
          <DialogTitle
            sx={{ pt: 3.75, pl: 3.75, pr: 3.75 }}
            className={cn(s.Modal__title, { isEmpty: !title, backroundedHeader })}
          >
            <>
              {title}
              <IconButton className={s.Modal__close} onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </>
          </DialogTitle>
          {withPadding ? (
            <DialogContent className={s.Modal__content} sx={{ pl: 3.75, pr: 3.75 }}>
              {children}
            </DialogContent>
          ) : (
            children
          )}
        </Box>
      </>
    </Dialog>
  );
};

export default Modal;
